import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, BookOpen, ExternalLink, Copy } from 'lucide-react';

const KidsBooksPage = () => {
  const navigate = useNavigate();
  const [copiedId, setCopiedId] = useState(null);

  const books = [
    {
      id: 1,
      title: "Adventures of Courtney Chipmunk",
      subtitle: "A Friendship Adventure",
      author: "Joseph Pasquaretto",
      description: "Join Courtney Chipmunk on an exciting adventure about friendship!",
      emoji: "🐿️",
      color: "from-amber-400 to-orange-500",
      link: "https://www.amazon.com/Adventures-Courtney-Chipmunk-Friendship-Adventure/dp/B0FTVN7WTZ/ref=sr_1_1?crid=UMKUL5LEXMYJ&dib=eyJ2IjoiMSJ9.rhrjx9f8yRqCheU45LD9oqKSV4N4erplgDNTohnxB5gOiU9CI3p9Q83-rlX-9x975EBmVX2TvghK6wt9kva_B63Pew1T4laTHxuvQskEqvk.idzAJkET9Uel6sIzXR-B_0dmT9vYlfcf8UBN9YDZc2A&dib_tag=se&keywords=joseph+pasquaretto&qid=1767294199&sprefix=joseph+pasq%2Caps%2C153&sr=8-1"
    },
    {
      id: 2,
      title: "Ava Otter's Adventure",
      subtitle: "In New York City",
      author: "Joseph Pasquaretto",
      description: "Follow Ava the Otter on an exciting trip through the Big Apple!",
      emoji: "🦦",
      color: "from-blue-400 to-cyan-500",
      link: "https://www.amazon.com/Ava-Otters-Adventure-York-City/dp/B0FWBRPCMM/ref=sr_1_2?crid=UMKUL5LEXMYJ&dib=eyJ2IjoiMSJ9.rhrjx9f8yRqCheU45LD9oqKSV4N4erplgDNTohnxB5gOiU9CI3p9Q83-rlX-9x975EBmVX2TvghK6wt9kva_B63Pew1T4laTHxuvQskEqvk.idzAJkET9Uel6sIzXR-B_0dmT9vYlfcf8UBN9YDZc2A&dib_tag=se&keywords=joseph+pasquaretto&qid=1767294199&sprefix=joseph+pasq%2Caps%2C153&sr=8-2"
    },
    {
      id: 3,
      title: "Billy Bulldog's Adventure",
      subtitle: "A Fun Journey",
      author: "Joseph Pasquaretto",
      description: "Join Billy the Bulldog on his amazing adventure!",
      emoji: "🐶",
      color: "from-red-400 to-rose-500",
      link: "https://www.amazon.com/Billy-Bulldogs-Adventure-Jospeh-Pasquaretto/dp/B0FTXC2QXW/ref=sr_1_3?crid=UMKUL5LEXMYJ&dib=eyJ2IjoiMSJ9.rhrjx9f8yRqCheU45LD9oqKSV4N4erplgDNTohnxB5gOiU9CI3p9Q83-rlX-9x975EBmVX2TvghK6wt9kva_B63Pew1T4laTHxuvQskEqvk.idzAJkET9Uel6sIzXR-B_0dmT9vYlfcf8UBN9YDZc2A&dib_tag=se&keywords=joseph+pasquaretto&qid=1767294199&sprefix=joseph+pasq%2Caps%2C153&sr=8-3"
    },
    {
      id: 4,
      title: "Courtney Chipmunk",
      subtitle: "The Acorn Treasure Hunt",
      author: "Joseph Pasquaretto",
      description: "Help Courtney find the hidden acorn treasure!",
      emoji: "🌰",
      color: "from-yellow-400 to-amber-500",
      link: "https://www.amazon.com/Courtney-Chipmunk-Acorn-Treasure-Hunt/dp/B0FWBR76B1/ref=sr_1_4?crid=UMKUL5LEXMYJ&dib=eyJ2IjoiMSJ9.rhrjx9f8yRqCheU45LD9oqKSV4N4erplgDNTohnxB5gOiU9CI3p9Q83-rlX-9x975EBmVX2TvghK6wt9kva_B63Pew1T4laTHxuvQskEqvk.idzAJkET9Uel6sIzXR-B_0dmT9vYlfcf8UBN9YDZc2A&dib_tag=se&keywords=joseph+pasquaretto&qid=1767294199&sprefix=joseph+pasq%2Caps%2C153&sr=8-4"
    },
    {
      id: 5,
      title: "Courtney Chipmunk",
      subtitle: "Becomes a Police Officer",
      author: "Joseph Pasquaretto",
      description: "Watch Courtney become a hero in uniform!",
      emoji: "👮",
      color: "from-indigo-400 to-blue-500",
      link: "https://www.amazon.com/Courtney-Chipmunk-Becomes-Police-Officer/dp/B0FTXDTXFS/ref=sr_1_5?crid=UMKUL5LEXMYJ&dib=eyJ2IjoiMSJ9.rhrjx9f8yRqCheU45LD9oqKSV4N4erplgDNTohnxB5gOiU9CI3p9Q83-rlX-9x975EBmVX2TvghK6wt9kva_B63Pew1T4laTHxuvQskEqvk.idzAJkET9Uel6sIzXR-B_0dmT9vYlfcf8UBN9YDZc2A&dib_tag=se&keywords=joseph+pasquaretto&qid=1767294199&sprefix=joseph+pasq%2Caps%2C153&sr=8-5"
    },
    {
      id: 6,
      title: "James Jaguar",
      subtitle: "The Rainforest Race of Friendship",
      author: "Joseph Pasquaretto",
      description: "Race through the rainforest with James the Jaguar!",
      emoji: "🐆",
      color: "from-green-400 to-emerald-500",
      link: "https://www.amazon.com/James-Jaguar-Rainforest-Race-Friendship/dp/B0FWJZ48Z2/ref=sr_1_6?crid=UMKUL5LEXMYJ&dib=eyJ2IjoiMSJ9.rhrjx9f8yRqCheU45LD9oqKSV4N4erplgDNTohnxB5gOiU9CI3p9Q83-rlX-9x975EBmVX2TvghK6wt9kva_B63Pew1T4laTHxuvQskEqvk.idzAJkET9Uel6sIzXR-B_0dmT9vYlfcf8UBN9YDZc2A&dib_tag=se&keywords=joseph+pasquaretto&qid=1767294199&sprefix=joseph+pasq%2Caps%2C153&sr=8-6"
    },
  ];

  const handleCopyLink = (book) => {
    const textArea = document.createElement('textarea');
    textArea.value = book.link;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      setCopiedId(book.id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (err) {
      prompt('Copy this link:', book.link);
    }
    
    document.body.removeChild(textArea);
  };

  const handleOpenLink = (url) => {
    // Try to open in new tab
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      // If blocked, redirect in same tab
      window.location.href = url;
    }
  };

  return (
    <div className="min-h-screen p-4 md:p-8" style={{
      background: 'linear-gradient(135deg, #a8e6cf 0%, #dcedc1 100%)'
    }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <Button
            onClick={() => navigate('/age-selection')}
            variant="ghost"
            className="text-lg font-semibold hover:scale-110 transition-transform bg-white/50 hover:bg-white/70"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </Button>
        </div>

        {/* Title */}
        <div className="text-center mb-10">
          <div className="text-6xl mb-4">📚</div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Kids Books
          </h1>
          <p className="text-xl text-gray-600">
            Discover amazing stories for young readers!
          </p>
        </div>

        {/* Books Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {books.map((book) => (
            <Card
              key={book.id}
              className="overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              style={{ borderRadius: '24px' }}
            >
              {/* Book Cover Area */}
              <div className={`h-48 bg-gradient-to-br ${book.color} flex items-center justify-center relative overflow-hidden`}>
                <div className="absolute inset-0 opacity-20">
                  <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-16 -translate-y-16"></div>
                  <div className="absolute bottom-0 right-0 w-24 h-24 bg-white rounded-full translate-x-12 translate-y-12"></div>
                </div>
                <span className="text-8xl">{book.emoji}</span>
              </div>

              {/* Book Info */}
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold text-gray-800 mb-1">{book.title}</h3>
                <p className="text-md font-semibold text-gray-500 mb-2">{book.subtitle}</p>
                <p className="text-sm text-gray-600 mb-1">By {book.author}</p>
                <p className="text-gray-600 text-sm mb-4">{book.description}</p>

                {/* Copy Link Button */}
                <button
                  onClick={() => handleCopyLink(book)}
                  className={`w-full mb-3 py-3 text-md font-bold transition-all duration-300 text-center border-2 rounded-xl ${
                    copiedId === book.id 
                      ? 'bg-green-100 border-green-500 text-green-600' 
                      : 'border-orange-500 text-orange-600 hover:bg-orange-50'
                  }`}
                >
                  {copiedId === book.id ? '✅ Link Copied!' : '📋 Copy Link'}
                </button>

                {/* View on Amazon Button */}
                <a
                  href={book.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full py-4 text-lg font-bold transition-all duration-300 text-white text-center rounded-xl"
                  style={{
                    background: `linear-gradient(135deg, #f59e0b, #d97706)`,
                  }}
                >
                  <BookOpen className="w-5 h-5 inline mr-2" />
                  View on Amazon
                </a>
              </div>
            </Card>
          ))}

          {/* Coming Soon Card */}
          <Card
            className="overflow-hidden transition-all duration-300 hover:scale-105 border-2 border-dashed border-gray-300"
            style={{ borderRadius: '24px' }}
          >
            <div className="h-48 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
              <span className="text-6xl opacity-50">📖</span>
            </div>
            <div className="p-6 bg-white text-center">
              <h3 className="text-xl font-bold text-gray-400 mb-2">More Books Coming Soon!</h3>
              <p className="text-gray-400">Stay tuned for more amazing stories...</p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default KidsBooksPage;
